module.exports = __webpack_public_path__ + "media/images/application/template/logos/ridgway-64d2fbf5408ecc09f8f251293d070041.png";